<template>
  <div>
    <BeAdditionalProductCard
      v-if="isV3"
      :hide-image="isProductImageHidden"
      :image="data.image_url"
      :name="data.name"
      :description="data.description"
      :price="$formatCurrency(data.price)"
      :unit="unitLabel"
      @detail="toggleDetail">
      <template #action>
        <button v-if="cart_qty == 0" class="be-ap-add-btn" @click="changeQty('plus')">Add to cart</button>
        <div v-else class="be-ap-qty">
          <span class="be-ap-qty__btn" @click="changeQty('minus')">−</span>
          <span class="be-ap-qty__num">{{ cart_qty }}</span>
          <span class="be-ap-qty__btn" @click="changeQty('plus')">+</span>
        </div>
      </template>
    </BeAdditionalProductCard>

    <div v-else class="w-100 radius-6 box-shadow-light-aff" :class="cart_qty == 0 ? 'border-form' : 'border-orange'">
    <div class="row slim-grid-row">
      <div class="col-4 cursor-pointer" @click="toggleDetail()">
        <div class="w-100" style="height: 140px;">
          <img :src="data.image_url" class="img-fit radius-l-6">
        </div>
      </div>
      <div class="col-8">
        <div class="position-relative product-info-height py-2 pr-3">
          <div class="mb-2">
            <p class="mb-0 body-2-4 text-truncate cursor-pointer">{{data.name}}</p>
            <p class="mb-0 body-3-3 html-desc cursor-pointer text-truncate-2" v-html="data.description"></p>
          </div>
          <div class="position-absolute w-100 d-flex justify-content-between align-items-center pr-2" style="bottom: 8px;left: 0px;">
            <div>
              <div class="no-ws w-100">
                <p class="mb-0 d-inline-block align-middle text-orange font-lato text-16">{{$formatCurrency(data.price)}}</p>
                <p v-if="$isNotEmpty(data.unit)" class="mb-0 d-inline-block align-middle body-3-3-1 ml-1"> / {{data.unit.unit}}</p>
              </div>
              <p class="body-3 mb-0 text-green text-uppercase cursor-pointer underline" @click="toggleDetail()">View Details</p>
            </div>
            <div :class="{
              'w-40': window_width >= 1400,
              'w-50': window_width < 1400 && window_width >= 1200,
              'w-30': window_width < 1200 && window_width >= 992
            }">
              <button 
                v-if="cart_qty == 0" 
                @click="changeQty('plus')" 
                class="w-100 g-btn g-btn-secondary g-btn-sm py-2">Add to cart</button>
              <div v-else class="row no-gutters">
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-orange" @click="changeQty('minus')">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1.71429H0V0H12V1.71429Z" fill="white"/>
                    </svg>
                  </div>
                </div>
                <div class="col-4 align-self-center text-center">
                  <p class="mb-0 font-lato text-14">{{ cart_qty  }}</p>
                </div>
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-orange ml-auto" @click="changeQty('plus')">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <b-modal
      v-model="show_detail"
      ref="product_detail"
      centered size="md" hide-header body-class="p-0" footer-class="p-0"
      :content-class="isV3 ? 'be-v3-modal' : ''">
      <div class="w-100 radius-6" :class="{ 'position-relative': isProductImageHidden }" style="overflow: hidden;">
        <!-- Close sits on the hero image; without it, it needs its own dark-stroke copy. -->
        <div v-if="isProductImageHidden" class="position-absolute cursor-pointer" style="right: 16px; top: 16px; z-index: 2;" @click="toggleDetail()">
          <svg width="14" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.261089 15.749C0.614234 16.0921 1.19944 16.0921 1.5425 15.749L8.00002 9.2915L14.4575 15.749C14.8006 16.0921 15.3959 16.1022 15.7389 15.749C16.082 15.3959 16.082 14.8208 15.7389 14.4777L9.28143 8.01011L15.7389 1.55259C16.082 1.20954 16.0921 0.624325 15.7389 0.281269C15.3858 -0.0718766 14.8006 -0.0718766 14.4575 0.281269L8.00002 6.73879L1.5425 0.281269C1.19944 -0.0718766 0.604144 -0.0819664 0.261089 0.281269C-0.0819664 0.634414 -0.0819664 1.20954 0.261089 1.55259L6.7186 8.01011L0.261089 14.4777C-0.0819664 14.8208 -0.0920566 15.406 0.261089 15.749Z" fill="#1a1a2e"/>
          </svg>
        </div>
        <div class="w-100 position-relative" style="height: 250px;" v-if="!isProductImageHidden">
          <img :src="data.image_url" :alt="data.name" class="img-fit">
          <div class="position-absolute radius-6 popup-close-btn" @click="toggleDetail()">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.261089 15.749C0.614234 16.0921 1.19944 16.0921 1.5425 15.749L8.00002 9.2915L14.4575 15.749C14.8006 16.0921 15.3959 16.1022 15.7389 15.749C16.082 15.3959 16.082 14.8208 15.7389 14.4777L9.28143 8.01011L15.7389 1.55259C16.082 1.20954 16.0921 0.624325 15.7389 0.281269C15.3858 -0.0718766 14.8006 -0.0718766 14.4575 0.281269L8.00002 6.73879L1.5425 0.281269C1.19944 -0.0718766 0.604144 -0.0819664 0.261089 0.281269C-0.0819664 0.634414 -0.0819664 1.20954 0.261089 1.55259L6.7186 8.01011L0.261089 14.4777C-0.0819664 14.8208 -0.0920566 15.406 0.261089 15.749Z" fill="white"/>
            </svg>
          </div>
        </div>
        <div class="p-4" style="max-height: 400px;overflow-y: auto;">
          <p class="mb-1 body-1-4" :class="{ 'pr-4': isProductImageHidden }">{{ data.name }}</p>
          <div class="d-flex mb-4 align-items-end">
            <p class="mb-0 text-orange font-lato text-16 mr-1">{{$formatCurrency(data.price)}}</p>
            <p v-if="$isNotEmpty(data.unit)" class="mb-0 body-3-3-1"> / {{data.unit.unit}}</p>
          </div>
          <div class="html-desc body-2-2" v-html="data.description"></div>
        </div>
      </div>
      <template slot="modal-footer">
        <div class="px-4 py-3 w-100 m-0">
          <state-button v-if="cart_qty == 0" variant="secondary" size="lg" block :click="addQtyFromDetail">Add To Cart</state-button>
          <div v-else class="w-100 d-flex justify-content-between align-items-center">
            <div>
              <span class="mb-0 body-2-2-1">Total Price</span>
              <p class="mb-0 text-18 text-orange font-lato">{{ $formatCurrency(data.price*cart_qty) }}</p>
            </div>
            <div class="w-30">
              <div class="row no-gutters">
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-orange" @click="changeQty('minus')">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1.71429H0V0H12V1.71429Z" fill="white"/>
                    </svg>
                  </div>
                </div>
                <div class="col-4 align-self-center text-center">
                  <p class="mb-0 font-lato text-16">{{ cart_qty  }}</p>
                </div>
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-orange ml-auto" @click="changeQty('plus')">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex';
  import BeAdditionalProductCard from '@/components/hotel/be/v3/BeAdditionalProductCard.vue';

  export default {
    components: {
      BeAdditionalProductCard
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      general_data: {
        type: Object,
        default: () => ({})
      },
      layout: {
        type: String,
        default: 'legacy'
      }
    },
    data() {
      return {
        show_detail: false,
        window_width: window.innerWidth
      }
    },
    computed:{
      ...mapGetters(['getBeCartAddtService']),
      isV3(){
        return this.layout === 'v3'
      },
      isProductImageHidden(){
        return this.$isProductImageHidden(this.general_data)
      },
      unitLabel(){
        return this.$isNotEmpty(this.data.unit) ? this.data.unit.unit : ''
      },
      cart_qty(){
        let product_cart = this.getBeCartAddtService.find(x=>x.data.id == this.data.id)
        if(product_cart) return product_cart.qty
        return 0
      }
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods:{
      ...mapMutations(['BeManipulateAddtService']),
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      changeQty(type){
      	let params = {
      		data: this.data,
      		qty: type == 'minus' ? -1 : 1
      	}
      	this.BeManipulateAddtService(params)
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      },
      addQtyFromDetail(){
        return new Promise((success,fail)=>{
          setTimeout(() => {
            this.changeQty('plus')
            this.toggleDetail()
          }, 300);
        })
      }
    }
  }
</script>
<style>
  .pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
  .popup-close-btn{
    width: 40px;
    height: 40px;
    top:16px;
    right: 16px;
    text-align: center;
    place-items: center;
    display: grid;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .product-info-height{
    height: 100%;
    /* padding: 1rem 1rem 58px 1rem; */
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/Product.vue